import { useContextSelector as useCS } from "use-context-selector"

import { AppContext } from "domain/application/AppContext"
import { appSelectors } from "domain/application/selectors"
import { UserContainer } from "domain/user/containers/UserContainer"
import { GlobalConfigContainer } from "domain/globalConfig/containers/GlobalConfigContainer"

export const Containers = () => {
  const isReady = useCS(AppContext, appSelectors.isReady)

  return (
    <>
      <UserContainer />
      {isReady && <GlobalConfigContainer />}
    </>
  )
}
